import React from 'react';
import { Box, Typography } from '@mui/material';
export const SectionHeading = ({children}) => {
  return (
    <Box sx={{marginTop: '25px'}}>
      <Typography variant="h3" component="h3">{children}</Typography>
    </Box>
  );
};

